import { render } from "./index.vue?vue&type=template&id=f276c51c"
import script from "./oracleServices?vue&type=script&lang=js&external"
export * from "./oracleServices?vue&type=script&lang=js&external"

import "./oracleServices.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__